import { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Header/Navbar";
import { AppContext, AppProvider } from "./Context/AppContext";
import Login from "./Config/Login";
import MobileNav from "./components/Mobilenav/MobileNav";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  clearSelectedData,
  clearBetData,
} from "../../AsianExchangeSrc/redux/slices/fullmarketSlice";
import {
  getUserId,
  isSignupUser,
  newSky,
  selectDomainID,
  selectSiteActiveTabBgColor,
  selectSiteName,
} from "../../AsianExchangeSrc/utils/helper/commonSelectors";
import {
  setUserOffline,
  setUserOnline,
  subscribeToJoinProfileRoom,
  subscribeToMatchData,
} from "../../socketClient";
import FinancialButtonsmb from "./components/FinancialButtonsmb";
import ChangePasswordModal from "../../ChangeUserPassword";
import { setUserFirstLogin } from "../../AsianExchangeSrc/redux/slices/userSlice";
import { setProfileDataFirstLogin } from "../../AsianExchangeSrc/redux/slices/accountSlice";
import "../src/assets/styles/Inplay.css";
import DownloadApp from "./components/DownloadApp";
import { getBetMinMaxSetting } from "../../AsianExchangeSrc/api";
import { setbetSettings } from "../../AsianExchangeSrc/redux/slices/betSettingsSlice";
import News from "./components/News/News";

const App = () => {
  const dispatch = useDispatch();
  const currentUserId = useSelector(getUserId());

  const initializeLocalStorageSettings = () => {
    const defaultSettings = {
      defaultStake: "",
      selectedStakes: [4, 30, 50, 200, 500, 1000],
      editStakes: [4, 30, 50, 200, 500, 1000],
      oddsHighlight: true,
      fancyBetAcceptOdds: true,
      sportsBookAcceptOdds: true,
      withCommission: false,
    };

    if (!localStorage.getItem("userSettings")) {
      localStorage.setItem("userSettings", JSON.stringify(defaultSettings));
    }
  };

  useEffect(() => {
    const userSettings = localStorage.getItem("userSettings");
    if (!userSettings) {
      initializeLocalStorageSettings();
    }
  }, []);
  useEffect(() => {
    if (currentUserId) {
      setUserOnline(currentUserId);
      return () => {
        setUserOffline(currentUserId);
      };
    }
  }, [currentUserId]);

  useEffect(() => {
    if (currentUserId) {
      // Initialize the socket connection when userId is available
      subscribeToJoinProfileRoom(currentUserId);
    }
  }, [currentUserId]);

  const location = useLocation();
  useEffect(() => {
    // Subscribe to all matches for each sport
    subscribeToMatchData({
      eventId: 4, // Cricket
      competitionId: null,
      matchId: null,
      marketId: null,
      sport: "cricket",
    });
    subscribeToMatchData({
      eventId: 1, // Soccer (fixed order to match your backend convention)
      competitionId: null,
      matchId: null,
      marketId: null,
      sport: "soccer",
    });
    subscribeToMatchData({
      eventId: 2, // Tennis
      competitionId: null,
      matchId: null,
      marketId: null,
      sport: "tennis",
    });
  }, []);
  useEffect(() => {
    const handleBeforeUnload = () => {
      dispatch(clearSelectedData());
      dispatch(clearBetData());
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      dispatch(clearBetData());
    };
  }, [dispatch, location]);

  return (
    <AppProvider>
      <MainApp />
    </AppProvider>
  );
};

const MainApp = () => {
  const { loginOpen } = useContext(AppContext);
  const IsLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const domainID = useSelector(selectDomainID());
  const SkyDesign = useSelector(newSky());
  const [isPassWordModalOpen, setIsPassWordModalOpen] = useState(false);
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.account.profileData);
  const isAuthenticated = useSelector((state) => state.user.isLoggedIn);
  const siteActiveTabBgColor = useSelector(selectSiteActiveTabBgColor());
  const signupUser = useSelector(isSignupUser());
  const siteName = useSelector(selectSiteName());
  useEffect(() => {
    if (IsLoggedIn) {
      const fetchInitialValues = async () => {
        const response = await getBetMinMaxSetting(domainID);
        if (!response?.success) {
          // toast.error("Network Error");
        } else {
          dispatch(setbetSettings(response?.data?.data));
        }
      };
      fetchInitialValues();
    }
  }, [IsLoggedIn]);
  useEffect(() => {
    if (isAuthenticated && userData?.isFirstLogin) {
      setIsPassWordModalOpen(true);
    }
  }, [isAuthenticated, userData]);

  const handlePasswordChangeSuccess = async () => {
    setIsPassWordModalOpen(false);

    // Update the admin data in redux to reflect isFirstLogin as false
    dispatch(setUserFirstLogin(false));
    dispatch(setProfileDataFirstLogin(false));
    toast.success("Password changed successfully");
  };

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />{" "}
      {SkyDesign === "true" && <DownloadApp />}
      <div style={{ "--active-tab-bg-color": siteActiveTabBgColor }}>
        <Navbar />
        {isAuthenticated && <News />}
      </div>
      {IsLoggedIn && signupUser && siteName !== "Blacklion Club" ? (
        <FinancialButtonsmb />
      ) : (
        ""
      )}
      <Outlet />
      <MobileNav />
      {loginOpen && <Login />}
      <ChangePasswordModal
        isOpen={isPassWordModalOpen}
        onClose={() => setIsPassWordModalOpen(false)}
        onSuccess={handlePasswordChangeSuccess}
      />
    </div>
  );
};

export default App;
